import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AddDeliveryAddressForm from "./AddAddress";
import OrderSummary from "./OrderSummary";
import Navbar from "../../../components/Navbar";
import { Loader } from "../../../components/Loader";
import Footer from "../../../components/Footer";

const steps = ["Login", "Delivery Address", "Order Summary", "Payment"];

export default function Checkout() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const stepParam = parseInt(queryParams.get('step'), 10) || 2;
  const [activeStep, setActiveStep] = useState(stepParam);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (activeStep !== stepParam) {
      navigate(`/checkout?step=${activeStep}`);
    }
    setLoading(false);
  }, [activeStep, stepParam, navigate]);

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    if (activeStep > 2) {
      setActiveStep((prevStep) => prevStep - 1);
    }
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <div className="bg-black text-white pt-40 min-h-screen h-fit">
      <Navbar />
      <div className="container mx-auto px-5 lg:px-32 text-white">
        {loading ? (
          <Loader />
        ) : (
          <div className="w-full">
            <div className="flex justify-between gap-5 mb-8">
              {steps.map((label, index) => (
                <div key={label} className="flex-1 text-center">
                  <div
                    className={`p-1 rounded-full mb-2 ${activeStep >= index + 1 ? "bg-blue-500" : "bg-gray-600"}`}
                  >
                    {index + 1}
                  </div>
                  <p className={`text-sm ${activeStep >= index + 1 ? "text-white" : "text-gray-500"}`}>
                    {label}
                  </p>
                </div>
              ))}
            </div>

            {activeStep === steps.length ? (
              <div className="text-center my-8">
                <h2 className="text-xl mb-4">All steps completed - you're finished</h2>
                <button
                  onClick={handleReset}
                  className="bg-blue-600 px-4 py-2 text-white rounded hover:bg-blue-700 transition"
                >
                  Reset
                </button>
              </div>
            ) : (
              <>
                <div className="flex justify-between mb-4">
                  <button
                    disabled={activeStep <= 2}
                    onClick={handleBack}
                    className="bg-gray-600 px-4 py-2 text-white rounded hover:bg-gray-700 transition disabled:opacity-50"
                  >
                    Back
                  </button>
                </div>

                <div className="my-5">
                  {activeStep === 2 && (
                    <AddDeliveryAddressForm handleNext={handleNext} />
                  )}
                  {activeStep === 3 && (
                    <OrderSummary />
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
